import Vue from 'vue'
import Vuex from 'vuex'
import {
    login,
    logout,
    getInfo,
    getRouters
} from '@/api/login'
import {
    getToken,
    setToken,
    removeToken,
    setAccessRoutes,
    removeAccessRoutes
} from '@/utils/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        token: getToken(),
        routes: [],
        name: '',
        avatar: '',
        roles: [],
        permissions: []

    },
    getters: {

    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_ROUTES: (state, routes) => {
            state.routes = routes
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions
        }
    },
    actions: {
        Login({
            commit
        }, userInfo) {
            const username = userInfo.username.trim()
            const password = userInfo.password
            const code = userInfo.code
            const uuid = userInfo.uuid
            return new Promise((resolve, reject) => {
                login(username, password, code, uuid).then(res => {
                    setToken(res.token)
                    commit('SET_TOKEN', res.token)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                getInfo(state.token).then(res => {
                    if (!res) return reject()
                    const user = res.user || {}
                    const avatar = user.avatar || "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png";
                    if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                        commit('SET_ROLES', res.roles)
                        commit('SET_PERMISSIONS', res.permissions)
                            // commit('SET_PERMISSIONS', ['system:user:add', 'system:user:edit'])
                    } else {
                        commit('SET_ROLES', ['ROLE_DEFAULT'])
                    }
                    commit('SET_NAME', user.userName)
                    localStorage.setItem('adminName',user.userName)
                    commit('SET_AVATAR', avatar)
                        // console.log(res)
                    // console.log('roles:' + res.roles)
                    // console.log('permissions:' + state.permissions)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 生成路由
        GenerateRoutes({
            commit
        }) {
            return new Promise(resolve => {
                // 向后端请求路由数据
                getRouters().then(res => {
                    commit('SET_ROUTES', res.data)

                    var _routes = res.data;
                    var _routesList = [];
                    for (let index = 0; index < _routes.length; index++) {
                        const x = _routes[index];
                        if (x.name == "Product") {
                            // console.log(x.children)
                            if (x.children) {
                                for (let index = 0; index < x.children.length; index++) {
                                    const y = x.children[index];
                                    _routesList.push(y.component)
                                }
                            }

                        }
                        if (x.name == "System") {
                            _routesList.push(x.name)
                        }
                    }
                    setAccessRoutes(_routesList)
                    resolve(res.data)
                })
            })
        },

        // 退出系统
        LogOut({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_ROLES', [])
                    commit('SET_PERMISSIONS', [])
                    removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 前端 登出
        FedLogOut({
            commit
        }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                removeAccessRoutes()
                resolve()
            })
        }
    }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js